import * as C from "@/components";
import Link from "next/link";
import VadImage from "vadimages-nextjs-image-optimizer";

export const AnnouncementSingularBanner = () => {
  return (
    <C.PageSection>
      <h2 className="mb-5 text-center">New releases</h2>
      <Link href="/singular">
        <C.Card className="relative max-w-[1158px] mx-auto max-md:min-h-[228px] hover:scale-[1.01] duration-500 hover:shadow-lg shadow-black/5">
          <div className="absolute hidden md:block top-5 left-8 lg:top-16 lg:left-28">
            <p className="text-[40px] font-semibold">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8E58E4] to-[#C63493]">
                See the future of vape
              </span>
            </p>
            <p className="text-[#414042]">Singular® Universal Vape Platform</p>
          </div>
          <div className="text-center p-12 block md:hidden">
            <p className="text-[40px] font-semibold leading-10 mb-6">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8E58E4] to-[#C63493]">
                See the future of vape
              </span>
            </p>
            <p className="text-[#414042]">Singular® Universal Vape Platform</p>
          </div>
          <VadImage
            src="/images/singular/singular-homepage-promo.1.png"
            alt="Singular Promo"
            width={1158}
            height={416}
          />
        </C.Card>
      </Link>
    </C.PageSection>
  );
};
